import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

// services
import {TasksService} from "../../../shared/services/tasks.service";
import {SnackbarService} from "../../../shared/services/snackbar.service";

// models
import {ApiMessage} from "../../../shared/models/api-message";
import {AuthService} from "../../../shared/services/auth.service";

@Component({
    selector: 'app-task-status-modal',
    templateUrl: './task-status-modal.component.html',
    styleUrl: './task-status-modal.component.scss'
})
export class TaskStatusModalComponent {

    public taskID = 0;
    public checked = false;
    public isSaved = false;
    public taskPriority = '';
    public taskStatus = '';

    constructor(private authService: AuthService,
                private tasksService: TasksService,
                private snackbarService: SnackbarService,
                private dialogRef: MatDialogRef<TaskStatusModalComponent>,
                @Inject(MAT_DIALOG_DATA)
                data: {
                    taskID: number,
                    taskPriority: string,
                    taskStatus: string
                }) {
        this.taskID = data.taskID;
        this.taskPriority = data.taskPriority;
        this.taskStatus = data.taskStatus;
    }

    public changeStatus(): void {
        this.isSaved = true;
        const userType = this.authService.user.type;
        const taskData = {
            priority: this.taskPriority,
            status: this.taskStatus,
        };
        this.tasksService.updateTask(userType, this.taskID, taskData).subscribe({
            next: (res: ApiMessage): void => {
                this.snackbarService.snackbarCustomComplete(res.message);
            },
            error: (e) => this.snackbarService.snackbarCustomError(e.error.message),
            complete: () => {
                this.isSaved = false;
                this.dialogRef.close();
            }
        })
    }
}
